export const inputs = {
    formName: 'changePasswordFormNoAuth',
    type: {
        password: 'password'
    },
    field: {
        newPassword: 'newPassword',
        newPasswordConfirm: 'newPasswordConfirm'
    }
}